import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Select,
  MenuItem,
  TextField,
  Avatar,
  Grid,
} from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DateDuration from '../../../components/DateDuration';
import Navigation from '../../../components/Navigation';

function ViewRequest() {
  const [leaveType, setLeaveType] = useState('');

  return (
    <Container
      maxWidth="sm"
      sx={{
        paddingTop: 4,
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
        <Avatar src="/path-to-image.jpg" alt="Molly Thomson" sx={{ mr: 2 }} />
        <Typography variant="body1" fontWeight="bold">
          Molly Thomson
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 2,
          width: '100%',
          margin: 'auto',
        }}
      >
        <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>
          Holiday Request
        </Typography>
        <Typography variant="body1" sx={{ color: 'gray', mt: 1 }}>
          Received on 10 November 2024
        </Typography>
      </Box>
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 3 }}
      >
        <Select
          value={leaveType}
          onChange={(e) => setLeaveType(e.target.value)}
          displayEmpty
          sx={{ width: '45%' }}
        >
          <MenuItem value="">Leave Type</MenuItem>
          <MenuItem value="sick">Sick Leave</MenuItem>
          <MenuItem value="annual">Annual Leave</MenuItem>
        </Select>

        <Button
          variant="outlined"
          startIcon={<AttachFileIcon />}
          sx={{ width: '45%' }}
        >
          Attachment
        </Button>
      </Box>
      <DateDuration duration={'2 days'} />

      <TextField
        fullWidth
        label="Message"
        variant="outlined"
        InputProps={{
          readOnly: true,
          sx: { height: '200px', alignItems: 'flex-start' },
        }}
        value={'Hi'}
        sx={{ mb: 2, mt: 2 }}
      />
      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Typography variant="subtitle1" color="textSecondary">
              Entitled
            </Typography>
            <Typography variant="h6">28</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="subtitle1" color="textSecondary">
              Taken
            </Typography>
            <Typography variant="h6">12</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="subtitle1" color="textSecondary">
              Balance
            </Typography>
            <Typography variant="h6">16</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="subtitle1" color="textSecondary">
              Pending
            </Typography>
            <Typography variant="h6">3</Typography>
          </Grid>
        </Grid>
      </Box>
      <Navigation />
    </Container>
  );
}

export default ViewRequest;
